module.exports = "../../ng-api-template.JPG";